import { generateNameFromEmail } from 'ts-utils';
import { Auth, BasicLoginDetails } from '../../../util/Auth';
import { generateRandomPassword } from '../../../util/Crypto';
import { ActionType } from '../../ActionTypes';
import { store as baseStore } from '../../Store';
import { prepareUserDataForPersistence } from '../../userData/PrepareUserDataForPersistence';
import { handleUserError, validateUserIsNotAuthenticated } from '../Utils';

export type TempRegisterDetails = Pick<BasicLoginDetails, 'email'>;

/** Registers a user with a temporary `name` and `password`, and updates the user state with the result.
 * The `name` and `password` should be replaced by real values in `finishPartialUserRegistration`. */
export async function temporaryRegisterUser(
  details: TempRegisterDetails,
  store = baseStore
): Promise<void> {
  try {
    store.dispatch({ type: ActionType.TEMPORARY_REGISTER_USER_LOADING });

    validateUserIsNotAuthenticated();

    const { email } = details;
    const {
      user: { name },
      userData: initialUserData,
    } = store.getState();
    const userData = prepareUserDataForPersistence(initialUserData);
    const tempName = name ?? generateNameFromEmail(email);
    const tempPassword = generateRandomPassword();

    const {
      user,
      paid: hasPaid,
      setUserPassword,
    } = await Auth.signUpAndRegisterForPayment({
      email,
      password: tempPassword,
      name: tempName,
      userData,
      isTemporaryRegister: true,
    });

    store.dispatch({
      type: ActionType.TEMPORARY_REGISTER_USER_SUCCESS,
      user: {
        ...user,
        type: 'partial',
        setUserPassword,
        hasPaid,
        tempPassword,
      },
    });
  } catch (rawError) {
    const error = handleUserError(rawError);
    store.dispatch({ type: ActionType.TEMPORARY_REGISTER_USER_FAILURE, error });
  }
}
